export const onboardingTasks = {
  core: [

    {
      id: 'createEvent',
      title: 'Create event',
      steps: [
        {
          id: 'eventCreated',
          message: {
            content: 'You have created an event. You can now manage guests, edit the event page, send email invites and track event stats.',
          },
          awaitingAction: null,
          anchors: [],
        },
      ],
    },

    {
      id: 'manageGuests',
      title: 'Manage guests',
      steps: [
        {
          id: 'addedGuest',
          message: {
            content: 'Add yourself to the guest list by clicking _*Add guest*_ and filling the information',
            icon: 'user-02',
          },
          awaitingAction: 'Waiting to add yourself as a guest',
          anchors: [
            {
              element: '[data-cy="builder-back-button"]',
              placement: 'bottom',
            },
            {
              element: 'aside [data-cy="guests"]',
              placement: 'bottom',
              offset: [0, 24],
            },
            {
              element: '[data-cy="guests-add-button"]',
              placement: 'bottom',
            },
          ],
        },
      ],
    },

    {
      id: 'editEventPage',
      title: 'Edit event page',
      steps: [
        {
          id: 'navigatedToPageBuilder',
          message: {
            content: 'Click on the event page you want to edit',
            icon: 'cursor-click-01',
          },
          awaitingAction: 'Waiting for you to open the page',
          anchors: [
            {
              element: '[data-cy="templates/page"]',
              placement: 'right',
            },
            {
              element: '[data-cy="template-page-item"]',
              placement: 'right',
            },
          ],
        },
        {
          id: 'editedEventPage',
          message: {
            content: 'Edit the sections by clicking _*Content*_ (for text and images) or _*Customize*_ (for design and layout changes).', // eslint-disable-line max-len
            icon: 'edit-01',
          },
          awaitingAction: null,
          anchors: [],
        },
        {
          id: 'copiedEventPageLink',
          message: {
            content: 'If you want to share the page link, you can do so by clicking _*Share > Copy link*_. If you plan to send email invites, there is no need to copy the link.', // eslint-disable-line max-len
            icon: 'globe-02',
          },
          awaitingAction: null,
          anchors: [{
            element: '[data-id="template-page-links-button"]',
            placement: 'bottom',
          }],
        },
      ],
    },


    {
      id: 'sendEmailInvites',
      title: 'Send email invites',
      steps: [
        {
          id: 'navigatedToEmailBuilder',
          message: {
            content: 'Go to the email invites through Templates > Emails, then select the invite.',
            icon: 'mail-01',
          },
          awaitingAction: 'Waiting for you to open the invite',
          anchors: [
            {
              element: '[data-cy="builder-back-button"]',
              placement: 'bottom',
            },
            {
              element: 'aside [data-cy="templates/email"]',
              placement: 'bottom',
              offset: [0, 24],
            },
            {
              element: '[data-cy="template-email-item"]',
              placement: 'right',
            },
          ],
        },
        {
          id: 'editedEmailTemplate',
          message: {
            content: 'You can edit the template the same way you edit the event page. You can set subject, sender and reply to email address in _*Settings*_ above.', // eslint-disable-line max-len
            icon: 'settings-01',
          },
          awaitingAction: null,
          anchors: [
            {
              element: '[data-cy="builder-back-button"]',
              placement: 'bottom',
            },
            {
              element: '[data-id="template-settings-button"]',
              placement: 'bottom',
            },
          ],
        },
        {
          id: 'navigatedToMailingSection',
          message: {
            content: 'You can send the invite by navigating back and clicking _*Mailing*_.',
            icon: 'cursor-click-01',
          },
          awaitingAction: 'Waiting for you to open the mailing',
          anchors: [
            {
              element: '[data-cy="builder-back-button"]',
              placement: 'bottom',
            },
            {
              element: 'aside [data-cy="mailing"]',
              placement: 'bottom',
              offset: [0, 24],
            },
          ],
        },
        {
          id: 'sentInvites',
          message: {
            content: 'Click _*New mailing*_ and select the template and recipients. In the recipients, you can select a specific guest by choosing _*Selected guests*_ and finding yourself on the guest list.', // eslint-disable-line max-len
            icon: 'send-01',
          },
          awaitingAction: 'Waiting for you to send invites',
          anchors: [
            {
              element: 'aside [data-cy="mailing"]',
              placement: 'bottom',
              offset: [0, 24],
            },
            {
              element: '[data-cy="open-mailing-create-dialog"]',
              placement: 'bottom',
            },
          ],
        },
        {
          id: 'confirmedAttendance',
          message: {
            content: 'Go to the inbox and confirm attendance by clicking the link in the email.',
            icon: 'mail-02',
          },
          awaitingAction: null,
          // awaitingAction: {
          //   pendingText: 'Waiting for you to confirm attendance',
          //   successText: 'Attendance confirmed',
          // },
          anchors: [],
        },
        {
          id: 'receivedEventRecapAndCalendarInvite',
          message: {
            content: 'Perfect! Youve also received an email with the event recap and calendar invite.',
            icon: 'users-02',
          },
          awaitingAction: null,
          anchors: [],
        },
      ],
    },

    {
      id: 'trackEventStats',
      title: 'Track event stats',
      steps: [
        {
          id: 'navigatedToGuests',
          message: {
            content: 'Navigate to the guest list to see real-time info about confirmations. You can see that you are marked as confirmed.', // eslint-disable-line max-len
            icon: 'user-check-01',
          },
          awaitingAction: 'Waiting for you to open the guest list',
          anchors: [{
            element: 'aside [data-cy="guests"]',
            placement: 'bottom',
            offset: [0, 24],
          }],
        },
        {
          id: 'navigatedToAnalytics',
          message: {
            content: 'You can also see the event stats in the analytics page.',
            icon: 'line-chart-up-02',
          },
          awaitingAction: 'Waiting for you to open analytics',
          anchors: [{
            element: 'aside [data-cy="analytics"]',
            placement: 'bottom',
            offset: [0, 24],
          }],
        },
        {
          id: 'askedAIToBuildAnything',
          message: {
            content: 'That\'s it! And one last thing... you can ALWAYS ask AI to build anything for you. Just try it out. Happy planning!', // eslint-disable-line max-len
            icon: 'star-06',
          },
          awaitingAction: null,
          anchors: [{
            element: '[data-id="sidechain-prompt-input"]',
            placement: 'top',
          }],
        },
      ],
    },
  ],
};

// Helper function to get all valid step IDs for a specific onboarding
export const getValidStepIds = (onboardingName) => {
  const tasks = onboardingTasks[onboardingName];
  if (!tasks) return [];

  return tasks.flatMap((task) => task.steps.map((step) => step.id));
};

// Helper function to get total number of steps
export const getTotalSteps = (onboardingName) => {
  return getValidStepIds(onboardingName).length;
};

// Helper function to check if all steps are completed
export const isOnboardingComplete = (onboardingName, completedSteps) => {
  const totalSteps = getTotalSteps(onboardingName);
  return completedSteps?.length === totalSteps || true; // TODO: Onboarding mechanism is temporarily turned off because of unclear UX
};
